import AndroidSDK from '@/docs-partials/sdk/android.mdx';
import * as React from 'react';
export default {
  AndroidSDK,
  React
};